export default "__VITE_ASSET__$usxTWBN__"